import { usePayloadStore } from '../stores/payload-store';
import { useJobDataStore } from '../stores/job-store';
import { useApplicationStore } from '../stores/application-store';

export function getQueryToSaveApplicationAfterAuth() {
    const application = useApplicationStore();
    const job = useJobDataStore();
    const payload = usePayloadStore();

    // Not reactive on purpose
    const { encryptedPayload, atsUserUuid } = payload;

    const redirectSuccess = new URL('/profil/bewerbungen', window.location.origin);
    redirectSuccess.searchParams.set('addedApplication', true);
    redirectSuccess.searchParams.set('company', job.isChiffre ? '' : job.companyName);

    const fallbackUrl = new URL('/bewerben', window.location.origin);
    fallbackUrl.searchParams.set('uuid', atsUserUuid);
    fallbackUrl.searchParams.set('payload', encryptedPayload);

    let action = {
        applicationUuid: application.uuid,
        type: 'application',
        redirectSuccess: redirectSuccess.href,
        fallbackUrl: fallbackUrl.href,
    };

    const registerState = btoa(JSON.stringify({
        ...action,
        redirectSuccess: redirectSuccess.href,
    }));
    action = btoa(JSON.stringify(action));

    return {
        state: action,
        registerState,
    };
}
